import React from 'react'

const About = () => {
  return (
    <h1>About This Project</h1>
  )
}

export default About;